export const convertDataToUrl = async (data: string): Promise<string> => {
  try {
    const res: Response = await fetch(data);
    const blob: Blob = await res.blob();
    return URL.createObjectURL(blob);
  } catch (e) {
    console.error('Error converting data to blob', e);
    return '';
  }
};

export const dataUrlToFile = async (dataUrl: string, fileName: string, fileType: string): Promise<File | undefined> => {
  try {
    const res: Response = await fetch(dataUrl);
    const blob: Blob = await res.blob();
    return new File([blob], fileName, { type: fileType });
  } catch (e) {
    console.error(`Error while fetching ${fileName}`, e);
    return;
  }
};

export const downloadPdf = (source: string, fileName: string): void => {
  const downloadLink = document.createElement('a');
  downloadLink.href = source;
  downloadLink.download = fileName;
  downloadLink.click();
};
